import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ILocationData } from '@web-nx-ng-tsc/web-shared-data-access';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

@Component({
  selector: 'lib-web-shared-ui-location-detail',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './lib-location-detail.component.html',
  styleUrl: './lib-location-detail.component.scss',
})
export class LibLocationDetailComponent {
  @Input() set data(value: ILocationData) {
    this.dataSignal.set(value);
    this.loggingService.log('LibLocationDetailComponent:', value);
  }
  @Input() set socialMedia(value: any) {
    this.loggingService.log('socialMedia:', value);
    // this.socialMediaSignal.set(value);
    if (Array.isArray(value)) {
      const filteredValue = value.filter((item) => item?.url !== null);

      this.socialMediaSignal.set(filteredValue);
    }
  }
  parseLocation(value: string): number {
    return parseFloat(value);
  }
  @Output() emitSocialMedia = new EventEmitter();
  @Output() emitLocationBranch = new EventEmitter();

  private readonly loggingService = inject(LoggingService);
  public readonly replaceBucket = new ReplaceBucket();

  dataSignal = signal<any>(undefined);
  socialMediaSignal = signal<any>(undefined);

  onClickLocationBranch(lat: string, lng: string) {
    const location = {
      location_lat: lat,
      location_lng: lng,
    };
    this.emitLocationBranch.emit(location);
    this.loggingService.log('Latitude:', lat, 'Longitude:', lng);
  }

  onClickSocialMedia(item: any) {
    this.emitSocialMedia.emit(item);
  }
}
